import validators from 'components/form/validator/validations';

/**
 * Validator.
 *
 * Pulling over the FieldControl validation so that it can be decoupled
 * and reused in state/store and service layer.
 *
 * Trying to emulate, where possible, a 'Laravel' style Validator.
 */
export default class Validator {
    /**
     * Instatiate the Validator.
     *
     * @param data
     * @param rules
     */
    constructor(data, rules) {
        this._data = data;
        this._rules = rules;
    }

    /**
     * Validate either a defined value against a set of rules
     * or perform a validation against all of the data that
     * is currently set on the Validator instance.
     * 
     * @param  value
     * @param  rules
     * 
     * @return bool     
     */
    validate(value = null, rules = null) {
        if (this._data ||this._rules) {
            return this.validateAll();
        }

        if (!rules) {
            return true;
        }

        if (!value) {
            return false;
        }

        return false;
    }

    /**
     * Validate all Data against Rules.
     * 
     * @return {bool}
     */
    validateAll() {
        if (!Object.keys(this._rules).length) {
            // We have no validation rules defined, so we must have a valid step
            return true;
        }

        return Object.keys(this._rules).reduce((valid, field) => {
            // Get field value using dot notation from _data object.
            let value = field.split('.').reduce((o,i) => o[i], this._data);

            return !valid ? valid : this._validate(value, this._rules[field]);
        }, true);
    }

    /**
     * Private Method: Validate a value against a set of rules.
     * 
     * @param  value
     * @param  rules
     * 
     * @return bool     
     */
    _validate(value, field) {
        return this._rulesFrom(field.rules).reduce((valid, rule) => !valid ? valid : this._runRule(field.type, rule, value), true);
    }

    /**
     * Run an individual rule.
     * 
     * @param  type 
     * @param  rule 
     * @param  value
     * 
     * @return bool
     */
    _runRule(type, rule, value) {
        const ruleParts = rule.split(':');
        return validators[type][ruleParts.shift()](value, ...ruleParts);
    }

    /**
     * Split rules out from a string of rules..
     * 
     * @param  rules 
     * 
     * @return       
     */
    _rulesFrom(rules) {
        return rules.split('|');
    }
}


// WEBPACK FOOTER //
// ./src/services/Validator.js